import { useTranslation } from 'react-i18next';

import { CustomModal } from 'components/shared';
import { useResponsiveLayout } from 'hooks/useResponsiveLayout';

import styles from './SuccessReportLostDamagedPalletsBySupplierModal.module.css';

type SuccessReportLostDamagedPalletsBySupplierModalProps = {
   opened: boolean;
   isSupplier?: boolean;
   onClose: () => void;
};

const SuccessReportLostDamagedPalletsBySupplierModal = ({
   opened,
   isSupplier,
   onClose,
}: SuccessReportLostDamagedPalletsBySupplierModalProps) => {
   const { t } = useTranslation();
   const { isTablet } = useResponsiveLayout();

   const modalBody = isSupplier
      ? t('report_pallets.success.supplier.description')
      : t('report_pallets.success.client.description');

   const innerTitle = isSupplier
      ? t('report_pallets.success.supplier.title')
      : t('report_pallets.success.client.title');

   const icon = isSupplier ? 'USER_EXCLAMATION' : 'THUMB_UP';

   return (
      <CustomModal
         opened={opened}
         onClose={onClose}
         innerTitle={innerTitle}
         icon={icon}
         primaryButtonProps={{
            text: t('common.close'),
            variant: isTablet ? 'filled-primary' : 'outlined-primary',
            onClick: onClose,
         }}
         modalContentClassName={styles.modalContent}
         centeredButtons
      >
         <p className={styles.text}>{modalBody}</p>
      </CustomModal>
   );
};

export default SuccessReportLostDamagedPalletsBySupplierModal;
